export const projects = [
  {
    id: 1,
    title: "Shadow Realm: Origins",
    category: "Game Development",
    type: "Mobile RPG",
    year: "2023",
    client: "Internal — AWWAL Studios",
    desc: "A full-cycle mobile RPG developed from scratch. We handled concept, art direction, game design, backend engineering, and live operations post-launch.",
    results: ["80K+ Downloads in 3 months", "4.6 App Store Rating", "#1 RPG Malaysia Charts"],
    tech: ["Unity", "C#", "AWS", "Firebase"],
    image: "https://public.readdy.ai/ai/img_res/9131177b9b867477cacc2e9ede11deb5.jpg",
    featured: true,
  },
  {
    id: 2,
    title: "GuildHub Platform",
    category: "Social Platform",
    type: "SaaS Platform",
    year: "2022",
    client: "Multiple Guild Partners",
    desc: "A comprehensive guild management SaaS platform used by 50+ active guilds. Features real-time chat, event tools, leaderboards, and recruitment automation.",
    results: ["50+ Guilds Onboarded", "300% Engagement Increase", "99.9% Uptime SLA"],
    tech: ["React", "Node.js", "PostgreSQL", "Redis"],
    image: "https://readdy.ai/api/search-image?query=dark%20modern%20dashboard%20platform%20SaaS%20guild%20management%20interface%20leaderboard%20analytics%20dark%20theme%20neon%20glow%20professional%20web%20application&width=700&height=440&seq=p2&orientation=landscape",
    featured: true,
  },
  {
    id: 3,
    title: "Neon Drift",
    category: "Game Development",
    type: "PC / Web Racing Game",
    year: "2023",
    client: "Internal — AWWAL Studios",
    desc: "A stylized neon racing game built for PC and browser with real-time multiplayer, global leaderboards, and a deep car customization system.",
    results: ["45K+ Registered Players", "1M+ Races Completed", "Featured on Steam Greenlight"],
    tech: ["Unreal Engine 5", "C++", "WebSocket", "GCP"],
    image: "https://readdy.ai/api/search-image?query=cyberpunk%20neon%20racing%20game%20screenshot%20interface%20dark%20futuristic%20UI%20speed%20race%20results%20leaderboard%20dashboard%20neon%20amber%20green%20dark&width=700&height=440&seq=p3&orientation=landscape",
    featured: false,
  },
  {
    id: 4,
    title: "CryptoForge",
    category: "Web3",
    type: "Blockchain Strategy Game",
    year: "2024",
    client: "Internal — AWWAL Web3 Division",
    desc: "A pioneering Web3 strategy game integrating NFT assets, on-chain economies, and player-owned marketplaces. Built on BNB Chain.",
    results: ["30K+ Wallet-Connected Users", "$2M+ In-game Economy Volume", "Top 10 BSC DApp"],
    tech: ["Solidity", "React", "Web3.js", "BNB Chain"],
    image: "https://readdy.ai/api/search-image?query=web3%20blockchain%20NFT%20game%20concept%20art%20mystical%20digital%20world%20with%20glowing%20symbols%20tokens%20dark%20fantasy%20landscape%20cinematic%20neon&width=700&height=440&seq=p4&orientation=landscape",
    featured: true,
  },
  {
    id: 5,
    title: "Esports Event Platform",
    category: "Engineering",
    type: "Tournament Infrastructure",
    year: "2024",
    client: "Regional Esports Federation",
    desc: "A full tournament management and broadcasting platform for a regional esports federation, supporting 500+ concurrent players and live stream integration.",
    results: ["12 Tournaments Hosted", "500+ Concurrent Players", "Live Stream Integration"],
    tech: ["Node.js", "Kubernetes", "Redis", "OBS API"],
    image: "https://readdy.ai/api/search-image?query=esports%20tournament%20stage%20arena%20event%20management%20platform%20dark%20background%20dramatic%20stage%20lighting%20professional%20competitive%20gaming%20event%20cinematic&width=700&height=440&seq=p5&orientation=landscape",
    featured: false,
  },
  {
    id: 6,
    title: "SocialPlay Community App",
    category: "Social Platform",
    type: "Community Mobile App",
    year: "2025",
    client: "SocialPlay Pte. Ltd.",
    desc: "A mobile community app for casual gamers to discover, join, and interact with gaming groups. Features AI-based match suggestions and in-app voice chat.",
    results: ["25K+ MAU", "4.5 Play Store Rating", "Featured by Google Play"],
    tech: ["React Native", "Python", "TensorFlow", "MongoDB"],
    image: "https://readdy.ai/api/search-image?query=mobile%20social%20app%20dark%20interface%20gaming%20community%20profiles%20chat%20rooms%20neon%20glow%20modern%20UI%20smartphone%20dark%20theme%20social%20network&width=700&height=440&seq=p6&orientation=landscape",
    featured: false,
  },
];

export const categories = ["All", "Game Development", "Social Platform", "Web3", "Engineering"];
